import { Box, Flex } from '@radix-ui/themes';
import { CommonCallout } from 'components/common/callouts';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonStepHeader } from 'components/machine/dialogs/installation/header';
import { t } from 'i18next';
import { IInstallStepDef } from 'interfaces/i-installation';
import { InstallStep } from 'lib_ts/enums/installation';
import { InstallStepStatus } from 'lib_ts/enums/machine.enums';
import { useMemo } from 'react';

interface IProps {
  steps: IInstallStepDef[];
}

export const StepCompletion = (props: IProps) => {
  const skipped = useMemo(() => {
    return props.steps
      .filter((s) => InstallStep.Completion !== s.id)
      .filter((s) => s.status !== InstallStepStatus.Complete);
  }, [props.steps]);

  const hasSkippedSteps = skipped.length > 0;

  return (
    <ErrorBoundary identifier="StepCompletion">
      <Flex direction="column" gap="4">
        <CommonStepHeader label="Completion" />

        {hasSkippedSteps ? (
          <>
            <Box>
              You've reached the end of the calibration process. Review your
              settings and test results to ensure everything looks correct.
            </Box>
            <Box>
              When you're ready, click Complete Machine Install to finalize your
              setup.
            </Box>
            <CommonCallout
              content={
                <>
                  The following steps haven't been marked as completed:
                  <ul
                    className="no-margin"
                    style={{ paddingInlineStart: '20px' }}
                  >
                    {skipped.map((s, i) => (
                      <li key={i}>{t(s.label)}</li>
                    ))}
                  </ul>
                </>
              }
            />
          </>
        ) : (
          <>
            <Box>
              Your Machine is now fully installed and ready for use! All
              settings have been calibrated, and the system is optimized for
              accurate performance.
            </Box>
            <Box>
              When you're ready, click Complete Machine Install to finalize your
              setup.
            </Box>
            <Flex justify="center">
              <Box>
                <img
                  style={{
                    width: '331px',
                  }}
                  src="/img/renders/installation-complete.svg"
                />
              </Box>
            </Flex>
          </>
        )}
      </Flex>
    </ErrorBoundary>
  );
};
